import { important } from 'polished'
import { svgColor, svgDashedBorder, svgUri } from '../../helpers'
import { StyleFn } from '..'

export const IconPhotoOutline = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.51 3h2.98c.794 0 1.077.045 1.385.144.308.1.574.253.815.469.24.215.423.438.823 1.123L17.25 6h1.545c1.114 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926v7.59c0 1.114-.116 1.519-.334 1.926a2.272 2.272 0 0 1-.945.945c-.407.218-.811.334-1.926.334H5.205c-1.115 0-1.519-.116-1.926-.334a2.272 2.272 0 0 1-.945-.945C2.116 18.314 2 17.91 2 16.795v-7.59c0-1.115.116-1.519.334-1.926.218-.407.538-.727.945-.945C3.686 6.116 4.09 6 5.205 6H6.75l.737-1.264c.4-.685.582-.908.823-1.123.24-.216.507-.37.815-.469C9.433 3.045 9.716 3 10.51 3zm0 2c-.546 0-.664.013-.771.048a.222.222 0 0 0-.094.054c-.084.075-.155.17-.43.642l-.737 1.264A2 2 0 0 1 6.75 8H5.205c-.427 0-.694.019-.849.049a.353.353 0 0 0-.134.049.275.275 0 0 0-.124.124.353.353 0 0 0-.049.134c-.03.155-.049.422-.049.849v7.59c0 .427.019.694.049.849.012.06.017.074.049.134a.275.275 0 0 0 .124.125c.06.031.073.036.134.048.155.03.422.049.849.049h13.59c.427 0 .694-.019.849-.049a.353.353 0 0 0 .134-.049.275.275 0 0 0 .125-.124.353.353 0 0 0 .048-.134c.03-.155.049-.422.049-.849v-7.59c0-.427-.019-.694-.049-.849a.353.353 0 0 0-.049-.134.275.275 0 0 0-.124-.124.353.353 0 0 0-.134-.049c-.155-.03-.422-.049-.849-.049H17.25a2 2 0 0 1-1.728-.992l-.737-1.264c-.275-.472-.346-.567-.43-.642a.222.222 0 0 0-.094-.054c-.107-.035-.225-.048-.77-.048H10.51zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="#000000"></path></g></svg>',
}

export const FileUpload: StyleFn = (theme) => {
  const {
    color,
    font,
    size: { spacing },
  } = theme

  const rootStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 312,
    padding: spacing[16],
    gap: spacing[8],
    color: color.getModalValues(color.text.primary),
    fontSize: font.size.small,
    borderRadius: 3,
    backgroundColor: color.palette.warmgrey[10],
  }

  return {
    root: {
      ...rootStyles,
      position: 'relative',
      backgroundImage: svgDashedBorder(color.palette.coolgrey[40], 3),
    },
    browse: {
      '& *[role=button]': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    files: {
      width: 312,
      marginTop: spacing[16],
      display: 'flex',
      flexDirection: 'column',
      gap: spacing[8],
    },
    message: {
      pointerEvents: 'none',
    },
    placeholder: {
      pointerEvents: 'none',
      width: spacing[40],
      height: spacing[40],
      backgroundImage: svgUri(svgColor(IconPhotoOutline.data, color.palette.coolgrey[40])),
    },
    supportedFiles: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    overlay: {
      ...rootStyles,
      // let drag event pass through to parent
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1,
      backgroundImage: svgDashedBorder(color.palette.primaryblue[50], 3, 4),
      '& $placeholder': {
        backgroundImage: svgUri(svgColor(IconPhotoOutline.data, '#86A8E9')),
      },
    },
  }
}

export const FileItem: StyleFn = (theme) => {
  const {
    color,
    font,
    size: { spacing },
  } = theme

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      borderRadius: 3,
      padding: `${spacing[12]} ${spacing[8]}`,
      gap: spacing[4],
      backgroundColor: color.palette.warmgrey[10],
      fontSize: font.size.medium,
    },
    name: {
      lineHeight: font.lineheight.small,
      padding: `${spacing[2]} ${spacing[32]} ${spacing[2]} 0`,
      wordWrap: 'break-word',
    },
    removeButton: important({
      position: 'absolute',
      top: spacing[8],
      right: spacing[8],
    }),
    retry: {
      paddingBottom: spacing[8],
    },
    retryButton: {
      alignSelf: 'baseline',
    },
    status: {
      display: 'flex',
      gap: spacing[8],
      alignItems: 'center',
      fontSize: font.size.small,
      '& svg, & i': {
        margin: 0,
        width: spacing[24],
        height: spacing[24],
        fontSize: spacing[24],
        fill: 'currentColor',
        display: 'inline-flex',
      },
    },
    _error: {
      '& $status': {
        color: color.palette.red[60],
      },
    },
    _success: {
      '& $status': {
        color: color.palette.green[60],
      },
    },
  }
}
